import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';
import Overlay from './Overlay';
import { generateEvent } from '../../../../utils/dataGrinch';
import MenuSublistFirst from './MenuSublistFirst';
import { gtmEventPush, gtmPagePush } from '../../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { withMenuPlpParam } from '../../../../utils/pageInfo';

const { navigation: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
class MenuList extends Component {
  constructor(props) {
    super(props);
    this.state = { isMouseInsideElement: false, isMouseInSideDiv: false };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isMouseInSideDiv === 'No' && prevProps.isMouseInSideDiv === 'Yes') {
      this.setState({ isMouseInSideDiv: false });
    }
  }

  mouseEnter = () => {
    this.setState({ isMouseInsideElement: true, isMouseInSideDiv: true });
  };

  mouseExit = () => {
    this.setState({ isMouseInsideElement: false });
  };

  linkClick(link, name) {
    gtmEventPush({
      event: 'menu_navigation_click',
      event_category: 'user interactions',
      event_action: 'menu navigation click',
      event_label: name,
      store_type: 'luxe',
      page_name: screenName,
      page_type: screenType
    });
    generateEvent({
      Event: 'HeaderClick',
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'desktop'
      }
    });
  }

  makeAbFlagUrl = url => {
    let { ABFlagObj } = this.props;
    const searchAbFlagObj = JSON.stringify(ABFlagObj);

    if (url.includes('?')) {
      return withMenuPlpParam(
        `${url}${Object.keys(ABFlagObj)?.length > 0 ? `&searchAbFlagObj=${searchAbFlagObj}` : ''}`
      );
    } else {
      return withMenuPlpParam(
        `${url}${Object.keys(ABFlagObj)?.length > 0 ? `?searchAbFlagObj=${searchAbFlagObj}` : ''}`
      );
    }
  };

  render() {
    const {
      data = {},
      newDesignLuxe,
      isBrands,
      isNewBrandDirectoryDesktop,
      ABFlagObj
    } = this.props;
    const { values = [], link = '', name = '', newFlag = false } = data;

    let {
      metaData: {
        sis = false,
        subHeaderHeight = 0,
        primaryHeaderHeight = 100,
        flyOutTopCoordinate = 87,
        current: { textColor = '#FFF' } = {}
      } = {}
    } = this.props;

    if (_isEmpty(values) && _isEmpty(name)) {
      return null;
    }

    let anchorTagHeight = '40px';
    let fontSize = '16px';
    let liStyle = {
      height: anchorTagHeight
    };
    if (!sis) {
      textColor = '#333';
      textColor = values ? textColor : '#b19975';
      flyOutTopCoordinate = 87;
    } else {
      anchorTagHeight = '45px';
      // if(subHeaderHeight == 70) {
      //   anchorTagHeight = "35px";
      // }
      liStyle = {
        height: anchorTagHeight,
        lineHeight: '35px'
      };
    }

    if (newDesignLuxe) subHeaderHeight = 55;

    if (subHeaderHeight == 70 && !newDesignLuxe) {
      anchorTagHeight = '30px';
      fontSize = '14px';
    }

    const { location = {} } = window;
    const { pathname } = location;

    const anchorStyle = { color: textColor, height: anchorTagHeight, fontSize };

    const specialClass = pathname === link && pathname !== '#' ? 'selected-category-header' : '';
    const anchorTag = (
      <a
        href={withMenuPlpParam(link)}
        style={anchorStyle}
        title={name.toUpperCase()}
				aria-label={name}
        data-test="link-style"
        onClick={() => this.linkClick(link, name, newDesignLuxe)}
        className={specialClass}
      >
        {name}
        {pathname !== link && newFlag && <span className="ic-newtag" />}
      </a>
    );

    const listId = values ? null : 'menu-highlight';
    const addBrandListClass = newDesignLuxe && isBrands ? 'brand-list-desktop-flyout' : '';
    const menuFlyoutClass =
      this.state.isMouseInSideDiv & this.state.isMouseInsideElement
        ? `menu-flyout ${addBrandListClass}`
        : `menu-flyout close-seo-dropdown-menu ${addBrandListClass}`;
    const dpOverlayClass = this.state.isMouseInsideElement
      ? 'dp-overlay'
      : 'dp-overlay close-seo-dropdown-overlay';
    const flyOutStyle = { top: `${sis ? subHeaderHeight : flyOutTopCoordinate}px` };
    const overlayStyle = {
      top: `${sis ? primaryHeaderHeight + subHeaderHeight : primaryHeaderHeight}px`
    };
    const overlayStyleNewLuxe = { top: '165px' };
    return (
      <li
        id={listId}
        style={liStyle}
        data-test={`li-${name}`}
        onMouseEnter={values.length ? this.mouseEnter : null}
        onMouseLeave={values.length ? this.mouseExit : null}
        onFocus={values.length ? this.mouseEnter : null}
        onBlur={values.length ? this.mouseExit : null}
      >
        {anchorTag}
        {values && (
          <div className={menuFlyoutClass} style={flyOutStyle}>
            <ul className="menu-lfirst">
              {newDesignLuxe ? null : <span className="shopby-text" aria-label="Shop by: ">Shop by: </span>}
              {values.map((data, j) => {
                return (
                  <MenuSublistFirst
                    key={j}
                    data={data}
                    linkClick={this.linkClick}
                    newDesignLuxe={newDesignLuxe}
                    isBrands={isBrands}
                    isNewBrandDirectoryDesktop={isNewBrandDirectoryDesktop}
                    makeAbFlagUrl={this.makeAbFlagUrl}
                  />
                );
              })}
            </ul>
          </div>
        )}
        {values && (
          <Overlay
            className={dpOverlayClass}
            onMouseEnter={this.mouseExit}
            style={newDesignLuxe ? overlayStyleNewLuxe : overlayStyle}
          />
        )}
      </li>
    );
  }
}

export default MenuList;
